import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);


export default function createStore(state) {
    return new Vuex.Store({

        state: Object.assign(
                {
                    user: null,
                    timezone: 'UTC',
                    isMobile: false,
                    layout: 'defaultLayout',
                    theme: 'dark',
                    pinnedLeagues: [],
                    favouriteMatches: [],
                    pinnedIccTypes: [],
                    apiResponse: {},
                }, state
                ),
//        state: state ? state : {
//            user: null,
//            layout: 'defaultLayout',
//            theme: 'dark',
//            pinnedLeagues: [],
//            favouriteMatches: [],
//            pinnedIccTypes: [],
//            apiResponse: {},
//        },
        getters: {
            getApiResponse: state => endpoint => {
                    return state.apiResponse[endpoint + ''] ? state.apiResponse[endpoint + ''] : null;
                },
            isLoggedIn(state) {
                return state.user ? true : false;
            },
            layout(state) {
                return state.layout
            },
            timezone(state) {
                return state.timezone
            },
            theme(state) {
                return state.theme
            },
            pinnedLeagues(state) {
                return state.pinnedLeagues
            },
            isLeaguePinned: state => league => {
                    return state.pinnedLeagues.some(item => item.id == league.id)
                },
            favouriteMatches(state) {
                return state.favouriteMatches
            },
            isMatchFavourited: state => matchSlug => {
                    return state.favouriteMatches.includes(matchSlug)
                },
            pinnedIccTypes(state) {
                return state.pinnedIccTypes
            },
            isIccTypePinned: state => type => {
                    return state.pinnedIccTypes.includes(type)
                },
            isCountryPinned: (state, getters) => country => {
                    return country.tournaments.every(league => getters.isLeaguePinned(league))
                }
        },
        mutations: {
            initialiseStore(state) {
                state.user = localStorage.getItem('user') || null;
                state.theme = localStorage.getItem('theme') || 'dark';
                state.pinnedLeagues = JSON.parse(localStorage.getItem('pinnedLeagues')) || [];
                state.favouriteMatches = JSON.parse(localStorage.getItem('favouriteMatches')) || [];
                state.pinnedIccTypes = JSON.parse(localStorage.getItem('pinnedIccTypess')) || [];
                state.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
                cookies.set('timezone',state.timezone);
            },
            setApiResponse(state, data) {
                return state.apiResponse[data.key] = data.data
            },
            deleteApiResponse(state, key) {
                delete state.apiResponse[key + ''];
            },
            SET_LAYOUT(state, payload) {
                state.layout = payload
            },
            switchTheme(state, theme) {
                state.theme = theme
                if (isBrowser) {
                    localStorage.setItem('theme', theme);
                    cookies.set('theme', theme);
                }
            },
            addPinnedLeague(state, league) {
                state.pinnedLeagues.push(league)
                if (isBrowser) {
                    localStorage.setItem('pinnedLeagues', JSON.stringify(state.pinnedLeagues))
                    cookies.set('pinnedLeagues', JSON.stringify(state.pinnedLeagues));
                }
            },
            removePinnedLeague(state, league) {
                state.pinnedLeagues.removeObjectById(league.id)
//                state.pinnedLeagues.splice(state.pinnedLeagues.indexOf(league), 1)
                if (isBrowser) {
                    localStorage.setItem('pinnedLeagues', JSON.stringify(state.pinnedLeagues))
                    cookies.set('pinnedLeagues', JSON.stringify(state.pinnedLeagues));
                }
            },
            addFavouriteMatch(state, matchSlug) {
                state.favouriteMatches.push(matchSlug)
                if (isBrowser) {
                    localStorage.setItem('favouriteMatches', JSON.stringify(state.favouriteMatches))
                    cookies.set('favouriteMatches', JSON.stringify(state.favouriteMatches));
                }
            },
            removeFavouriteMatch(state, matchSlug) {
                state.favouriteMatches.splice(state.favouriteMatches.indexOf(matchSlug), 1)
                if (isBrowser) {
                    localStorage.setItem('favouriteMatches', JSON.stringify(state.favouriteMatches))
                    cookies.set('favouriteMatches', JSON.stringify(state.favouriteMatches));
                }
            },
            addPinnedIccType(state, type) {
                state.pinnedIccTypes.push(type)
                if (isBrowser) {
                    localStorage.setItem('pinnedIccTypess', JSON.stringify(state.pinnedIccTypes))
                    cookies.set('pinnedIccTypess', JSON.stringify(state.pinnedIccTypes));
                }
            },
            removePinnedIccType(state, type) {
                state.pinnedIccTypes.splice(state.pinnedIccTypes.indexOf(type), 1)
                if (isBrowser) {
                    localStorage.setItem('pinnedIccTypess', JSON.stringify(state.pinnedIccTypes))
                    cookies.set('pinnedIccTypess', JSON.stringify(state.pinnedIccTypes));
                }
            }
        },
        actions: {
        }

    })
}
